import Form from "../modules/form";
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

const Investors = {
  init() {
    new Form("#loyalty-form");
    this.countryCodes();
    this.numberGlue();
  },

  countryCodes() {
    const input = document.querySelector("#mobile-code");
    intlTelInput(input, {
      initialCountry: "lv",
      nationalMode: false,
      showSelectedDialCode: true,
    });
  },

  numberGlue() {
    $("button[type='submit']").on("click", function () {
      const code = $(".iti__selected-dial-code").text();
      const number = $("#mobile-code").val();
      const fullNumber = code + number;
      $("input[name='phone_full']").val(fullNumber);
    });
  }

};

export default Investors;
